import { ActionButton } from '../../components/vertical-dot/popper';
import type { Wealthlane_AwardSettlementService_Dtos_BrokerTradeTool_CsTransactionHistoryDto } from '@wealthlane/api-services/wealthlane-award-settlement-service';

interface BrokerTradeHistoryHeaderProps {
  actions: Record<string, any>[];
  getHistoryActions: (row: Wealthlane_AwardSettlementService_Dtos_BrokerTradeTool_CsTransactionHistoryDto) => any[];
}

interface CellProps {
  row: any;
  cell: any;
}

const BrokerTradeHistoryHeader = ({
  actions,
  getHistoryActions,
}: BrokerTradeHistoryHeaderProps) => {
  const renderActionsCell = ({ row, cell }: CellProps) => {
    const rowData = row?.original as Wealthlane_AwardSettlementService_Dtos_BrokerTradeTool_CsTransactionHistoryDto;
    const rowIndex = cell?.row?.index?.toString();

    return (
      <td
        id={`cell.${rowIndex}.actions`}
        style={{
          minWidth: cell.column.minWidth,
          width: cell.column.width,
          textAlign: 'center',
        }}>
        <ActionButton
          actions={getHistoryActions(rowData)}
          id={rowData?.tradeOrderId || rowData?.transactionId}
          counter={rowIndex}
          hideMenuOnActionClick
        />
      </td>
    );
  };

  const newActions = [
    ...(actions || []),
    {
      Header: 'Action',
      accessor: 'actions',
      width: 60,
      sortable: false,
      renderCell: true,
      center: true,
      Cell: renderActionsCell,
    },
  ];

  return newActions;
};

export default BrokerTradeHistoryHeader;
